import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const getHeaders = () => {
  const lang = localStorage.getItem("lang") || "en";

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Accept-Language": lang,
  };
};

const buildQueryParams = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });

  return query.toString();
};

export const getProductReportFilters = async () => {
  try {
    const response = await api.get(
      `${API_BASE_URL}api/product-report/filters`,
      {
        headers: getHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Get Product Report Filters API Error:", error);
    throw error?.response?.data || {
      message: "Failed to fetch product report filters",
    };
  }
};

export const getProductReportList = async (params = {}) => {
  try {
    const queryString = buildQueryParams(params);
    const url = `${API_BASE_URL}api/product-report/list${
      queryString ? `?${queryString}` : ""
    }`;

    const response = await api.get(url, {
      headers: getHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error("Get Product Report API Error:", error);
    throw error?.response?.data || {
      message: "Failed to fetch product report",
    };
  }
};

export const getProductReportSummary = async (params = {}) => {
  try {
    const queryString = buildQueryParams(params);
    const url = `${API_BASE_URL}api/product-report/summary${
      queryString ? `?${queryString}` : ""
    }`;

    const response = await api.get(url, {
      headers: getHeaders(),
    });

    return response.data;
  } catch (error) {
    console.error("Get Product Report Summary API Error:", error);
    throw error?.response?.data || {
      message: "Failed to fetch product report summary",
    };
  }
};

export const downloadProductReportExcel = async (params = {}) => {
  try {
    const queryString = buildQueryParams(params);
    const url = `${API_BASE_URL}api/product-report/download/excel${
      queryString ? `?${queryString}` : ""
    }`;

    const response = await api.get(url, {
      headers: getHeaders(),
      responseType: "blob",
    });

    const blob = new Blob([response.data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `product-report-${Date.now()}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

    return true;
  } catch (error) {
    console.error("Download Product Report Excel API Error:", error);
    throw error?.response?.data || {
      message: "Failed to download product report excel",
    };
  }
};

export const downloadProductReportPdf = async (params = {}) => {
  try {
    const queryString = buildQueryParams(params);
    const url = `${API_BASE_URL}api/product-report/download/pdf${
      queryString ? `?${queryString}` : ""
    }`;

    const response = await api.get(url, {
      headers: getHeaders(),
      responseType: "blob",
    });

    const blob = new Blob([response.data], {
      type: "application/pdf",
    });

    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = `product-report-${Date.now()}.pdf`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);

    return true;
  } catch (error) {
    console.error("Download Product Report PDF API Error:", error);
    throw error?.response?.data || {
      message: "Failed to download product report pdf",
    };
  }
};